import { gsap, ScrollTrigger } from "gsap/all";

const scaleUp = () => {
	gsap.registerPlugin(ScrollTrigger);

	// we get all the paths on the page minus the ones we want to exclude
	const shapes = gsap.utils.toArray(".animate--scale-up");

	// each path will be its own trigger
	shapes.forEach((shape) => {
		const offset = shape.dataset.startOffset ?? "-200";
		gsap.from(shape, {
			// eslint-disable-line
			scale: 0,
			scrollTrigger: {
				trigger: shape,
				start: `top+=${offset} center+=100`,
				toggleActions: "play none none reverse",
			},
		});
	});
};

export default scaleUp;
